import {
  CLOZE_TEXT,
  SHORT_TEXT,
  TRUE_OR_FALSE,
} from '@edulastic/constants/const/questionType'
import { Typography } from 'antd'
import React from 'react'
import { StyledQuestionListItem } from './styled'
import { ANSWER_OPTION_DELIMITER } from '../constants/test'
import { getQuestionDisplayContent } from '../utils/common'

const QuestionView = ({ question, questionType, questionIndex }) => {
  const {
    name = '',
    correctAnswer = false,
    correctAnswerIndex = -1,
    correctAnswersIndex = [],
    options = [],
  } = question

  const getAnswerContent = () => {
    if (questionType === TRUE_OR_FALSE) {
      return (
        <Typography.Paragraph>
          <ol type="A">
            <StyledQuestionListItem
              isBold={correctAnswer}
              data-cy="original-option-true"
            >
              <Typography.Text strong={correctAnswer}>True</Typography.Text>
            </StyledQuestionListItem>
            <StyledQuestionListItem
              isBold={!correctAnswer}
              data-cy="original-option-false"
            >
              <Typography.Text strong={!correctAnswer}>False</Typography.Text>
            </StyledQuestionListItem>
          </ol>
          <Typography.Text>
            <b>Correct answer: </b>
            <span data-cy="correct-answer">
              {correctAnswer
                ? `A${ANSWER_OPTION_DELIMITER} True`
                : `B${ANSWER_OPTION_DELIMITER} False`}
            </span>
          </Typography.Text>
        </Typography.Paragraph>
      )
    }
    if (questionType === CLOZE_TEXT) {
      return (
        <Typography.Paragraph>
          <Typography.Text>
            <b>Correct answer{options?.length > 1 ? 's' : ''}: </b>
            <span data-cy="correct-answer">
              {options.map((option, idx) => {
                return (
                  <>
                    {option.name}
                    {idx < options.length - 1 ? <b>, </b> : null}
                  </>
                )
              })}
            </span>
          </Typography.Text>
        </Typography.Paragraph>
      )
    }
    if (questionType === SHORT_TEXT) {
      return (
        <Typography.Paragraph>
          <Typography.Text>
            <b>Correct answer: </b>
            <span data-cy="correct-answer">{options[0]?.name}</span>
          </Typography.Text>
        </Typography.Paragraph>
      )
    }
    return (
      <Typography.Paragraph>
        <ol type="A">
          {options.map(({ name: optionText }, index) => {
            const isCorrectAnswer =
              (correctAnswersIndex || []).includes(index) ||
              index === correctAnswerIndex

            return (
              <StyledQuestionListItem isBold={isCorrectAnswer}>
                <Typography.Text strong={isCorrectAnswer}>
                  <span data-cy={`original-option-${index}`}>{optionText}</span>
                </Typography.Text>
              </StyledQuestionListItem>
            )
          })}
        </ol>
        <Typography.Text>
          <b>Correct answer{correctAnswersIndex?.length > 1 ? 's' : ''}: </b>
          <span data-cy="correct-answer">
            {options
              .reduce(
                (correctAnswersTextArray, { name: optionText }, index) => {
                  if (
                    (correctAnswersIndex || []).includes(index) ||
                    index === correctAnswerIndex
                  ) {
                    correctAnswersTextArray.push(
                      `${String.fromCharCode(
                        65 + index
                      )}${ANSWER_OPTION_DELIMITER} ${optionText}`
                    )
                  }

                  return correctAnswersTextArray
                },
                []
              )
              .join(', ')}
          </span>
        </Typography.Text>
      </Typography.Paragraph>
    )
  }
  return (
    <>
      <Typography.Paragraph data-cy="original-question-text">
        {questionIndex ? <b>Q{questionIndex}. </b> : ''}
        {getQuestionDisplayContent({ stimulus: name, questionType })}
      </Typography.Paragraph>
      {getAnswerContent()}
    </>
  )
}

export default QuestionView
